<div class="animated fadeIn container-fluid" [formGroup]="form">
    <h4> {{ title }} Tratamiento de Desinfección</h4>

    <div class="row">
        <div class="col-md-12">

            <div class="row">

                <div class="col-md-12">
                    <div class="card card-accent-success animated fadeIn">
                        <a class="card-header-a" (click)="isCollapsedCabecera = !isCollapsedCabecera" [attr.aria-expanded]="!isCollapsedCabecera" aria-controls="collapseExample">
                            <div class="card-header-buscador">
                                <i class="fa fa-file-text-o"></i> Datos del Tratamiento de Desinfección
                                <i *ngIf="isCollapsedCabecera" class="fa fa-caret-down float-right"></i>
                                <i *ngIf="!isCollapsedCabecera" class="fa fa-caret-up float-right"></i>
                            </div>
                        </a>
                        <div class="card-body-detalle">
                            <div class="collapse group-filtros" id="collapsedCabecera" [ngbCollapse]="isCollapsedCabecera">

                                <div class="row">

                                    <div class="form-group col-md-4">
                                        <label class="col-form-label required-field" for="inpCampania">Campaña</label>

                                        <ng-select [items]="campanias"
                                                   appendTo="body"
                                                   bindLabel="Descripcion"
                                                   bindValue="Id"
                                                   formControlName="IdCampania"
                                                   loadingText="Cargando..."
                                                   [loading]="!campanias"
                                                   notFoundText="Campaña no encontrada"
                                                   placeholder="-- Seleccione una Campaña --"
                                                   clearAllText="Eliminar seleccion"
                                                   [ngClass]="displayFieldCssNgSelect('IdCampania')"
                                                   [readonly]="tratamientoDesinfeccion?.FechaBaja">
                                        </ng-select>
                                        <div class="invalid-feedback" *ngIf="isFieldInvalid('Descripcion','required')">
                                            La campaña es obligatoria
                                        </div>
                                    </div>

                                    <div class="form-group col-md-4">
                                        <label class="col-form-label" for="inpFechaCreacion">Fecha de Creación</label>
                                        <input formControlName="FechaCreacion" name="FechaCreacion" class="form-control" readonly inputStyleClass="form-control"
                                               [ngClass]="displayFieldCss('FechaCreacion')" type="text" value="">
                                    </div>

                                    <div class="form-group col-md-4">
                                        <label class="col-form-label" for="inpFechaBaja">Fecha de Baja</label>
                                        <input formControlName="FechaBaja" name="FechaBaja" class="form-control" readonly inputStyleClass="form-control"
                                               [ngClass]="displayFieldCss('FechaBaja')" type="text" value="">
                                    </div>

                                    <div class="form-group col-md-4">
                                        <label class="col-form-label" for="inpActivo">Activo</label>
                                        <p-toggleButton class="form-control-togglebutton"
                                                        formControlName="Activo"
                                                        name="Activo"
                                                        onLabel="Sí"
                                                        offLabel="NO"
                                                        onIcon="pi pi-check"
                                                        offIcon="pi pi-times">                                                       
                                        </p-toggleButton>
                                    </div>

                                    <div class="form-group col-md-4">
                                        <label class="col-form-label " for="inpTratamiento">Tratamiento</label>
                                        <textarea style="resize:none" formControlName="Tratamiento" name="Tratamiento" class="form-control" maxlength="150" inputStyleClass="form-control" rows="3" type="text" value="" [readonly]="tratamientoDesinfeccion?.FechaBaja"></textarea>
                                    </div>

                                    <div class="form-group col-md-4">
                                        <label class="col-form-label " for="inpProdQuimico">Producto Químico</label>
                                        <textarea style="resize:none" formControlName="ProductoQuimico" name="ProductoQuimico" class="form-control" maxlength="150" inputStyleClass="form-control" rows="3" type="text" value="" [readonly]="tratamientoDesinfeccion?.FechaBaja"></textarea>

                                    </div>

                                    <div class="form-group col-md-4">
                                        <label class="col-form-label " for="inpConcentracion">Concentración</label>
                                        <input formControlName="Concentracion" name="Concentracion" class="form-control" maxlength="50" inputStyleClass="form-control" type="text" value="" [readonly]="tratamientoDesinfeccion?.FechaBaja">

                                    </div>

                                    <div class="form-group col-md-4">
                                        <label class="col-form-label " for="inpDuracion">Duración</label>
                                        <input formControlName="Duracion" name="Duracion" class="form-control" maxlength="50" inputStyleClass="form-control" type="text" value="" [readonly]="tratamientoDesinfeccion?.FechaBaja">
                                    </div>

                                    <div class="form-group col-md-4">
                                        <label class="col-form-label " for="inpTemperatura">Temperatura</label>
                                        <input formControlName="Temperatura" name="Temperatura" class="form-control" maxlength="50" inputStyleClass="form-control" type="text" [readonly]="tratamientoDesinfeccion?.FechaBaja">
                                    </div>

                                    <div class="form-group col-md-4">
                                        <label class="col-form-label" for="inpFecha">Fecha</label>
                                        <p-calendar formControlName="Fecha"
                                                    inputStyleClass="form-control"
                                                    [showIcon]="true"
                                                    [firstDayOfWeek]="1"
                                                    dateFormat="dd/mm/yy"
                                                    [readonlyInput]="tratamientoDesinfeccion?.FechaBaja">

                                        </p-calendar>
                                    </div>

                                    <div class="form-group col-md-12">
                                        <label class="col-form-label " for="inpInfAdicional">Información Adicional</label>
                                        <textarea style="resize:none" formControlName="InformacionAdicional" name="InformacionAdicional" class="form-control" maxlength="500" inputStyleClass="form-control" rows="6" type="text" value="" [readonly]="tratamientoDesinfeccion?.FechaBaja"></textarea>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>

    </div>
</div>
